import type { SelectOptions } from '../../components/Select/Select'

// While the server side entity name is ChecklistType, "type" is ambiguous in TS, so we use "kind" instead.
export enum ChecklistKind {
  CenterDayOpen = 'center_day_open',
  CenterDayClose = 'center_day_close',
  VehiclePrepare = 'vehicle_prepare',
  VehiclePreflight = 'vehicle_preflight',
  VehiclePostflight = 'vehicle_postflight',
  LaunchpadDayOpen = 'launchpad_day_open',
  LaunchpadDayClose = 'launchpad_day_close',
}

export const CHECKLIST_KIND_DISPLAY_NAMES: { [key in ChecklistKind]: string } = {
  [ChecklistKind.CenterDayOpen]: 'Open Center',
  [ChecklistKind.CenterDayClose]: 'Close Center',
  [ChecklistKind.VehiclePreflight]: 'Vehicle Preflight',
  [ChecklistKind.VehiclePostflight]: 'Vehicle Postflight',
  [ChecklistKind.VehiclePrepare]: 'Vehicle Prepare',
  [ChecklistKind.LaunchpadDayOpen]: 'Vehicle Day Open',
  [ChecklistKind.LaunchpadDayClose]: 'Vehicle Day Close',
}

export const checklistKindSelectOptions: SelectOptions = Object.entries(CHECKLIST_KIND_DISPLAY_NAMES).map(
  ([checklistKind, displayName]) => ({ value: checklistKind, text: displayName }),
)
